import { useGetAll, useGetOne } from "./crudService";

const endpoint:string = 'coordinating-programs';

export function useGetAllCoordinatingPrograms(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetCoordinatingProgram(id: number, queryParams:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...queryParams});
}

/*
// these aren't needed here
export function useCreateCoordinatingProgram() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateCoordinatingProgram({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteCoordinatingProgram({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
*/

// tood: format them
